import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    CommonModule, 
    RouterLink
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  date :any
  ngOnInit(): void {
    this.date = new Date().getFullYear();
  }
  social = [
    {
      icon:'facebook',
      link:'https://www.facebook.com/harmonest'
    },
    {
      icon:'instagram',
      link:'https://www.instagram.com/harmonest/'
    },
    {
      icon:'twitter',
      link:'https://twitter.com/harmonest'
    },
    {
      icon:'linkedin',
      link:'http://linkedin.com/company/harmonest'
    },
    {
      icon:'mail',
      link:'mailto:support@harmonest.com'
    },
  ]

  company = [
    {
      link:'/aboutus',
      name:'About Us'
    },
    {
      link:'/properties',
      name:'Browse Properties'
    },
    {
      link:'/host',
      name:'Become a Host'
    },
    {
      link:'/support',
      name:'Support'
    },
    {
      link:'/blog',
      name:'Blog'
    },
    {
      link:'/login',
      name:'Sign In'
    },
  ]
}
